import { useInfiniteQuery } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { ServiceTypeId } from '@/services/api/petseo.client.wrapper';
import { serviceVendorKeys } from '@petseo/shared';

export const useServiceVendors = (serviceTypeId: ServiceTypeId | null | undefined, name: string | null | undefined, elements: number = 10) => {
  return useInfiniteQuery({
    queryKey: serviceVendorKeys.list({ serviceTypeId, name, elements }),
    queryFn: async ({ pageParam = 1 }) => {
      const response = await serviceVendorsClient.getServiceVendorsEndpoint(serviceTypeId, name, pageParam, elements);
      return response.data;
    },
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.serviceVendors && lastPage.serviceVendors.length === elements) {
        return allPages.length + 1;
      }
      return undefined;
    },
    initialPageParam: 1,
  });
};
